import React, { useState, useEffect } from "react";
import { useMsal } from "@azure/msal-react";

import { Link, useLocation, useNavigate } from "react-router-dom";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import styles from "./VerticalNavbar.module.css";
import StarLogo from "../../../assets/SVGs/logo/Logo.svg";
import ShortLogo from "../../../assets/SVGs/logo/ShortLogo.svg";
import HomeIcon from "../../../assets/SVGs/home_icon.svg";
import DocIcon from "../../../assets/SVGs/doc_icon.svg";
import UserImg from "../../../assets/images/dummyUser.jpg";

import { Button, Typography } from "@mui/material";

const VerticalNavbar: React.FC = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [isCollapsed, setIsCollapsed] = useState<boolean>(false);
  const [isDropdownOpen, setIsDropdownOpen] = useState<boolean>(false);
  const [activePage, setActivePage] = useState<string>("");
  const [showLogout, setShowLogout] = useState<boolean>(false);
  const [userImage, setUserImage] = useState<string | null>(null);
  const [imageLoading, setImageLoading] = useState<boolean>(true);
  const { instance } = useMsal();
  const role = localStorage.getItem("role");

  useEffect(() => {
    setActivePage(location.pathname);
    if (
      location.pathname.includes("/operations/strategy-value-creation") ||
      location.pathname.includes("/operations/management") ||
      location.pathname.includes("/operations/people")
    ) {
      setIsDropdownOpen(true);
    } else {
      setIsDropdownOpen(false);
    }
  }, [location.pathname]);

  useEffect(() => {
    const fetchUserImage = async () => {
      const token = localStorage.getItem("tokenKey");
      if (!token) return;

      try {
        const response = await fetch("https://graph.microsoft.com/v1.0/me/photo/$value", {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });

        if (response.ok) {
          const imageBlob = await response.blob();
          const imageUrl = URL.createObjectURL(imageBlob);
          setUserImage(imageUrl);
        } else {
          // If the request fails (404 or other error), use the default image
          setUserImage(null);
        }
      } catch (error) {
        console.error("Error fetching user image:", error);
        setUserImage(null);
      } finally {
        setImageLoading(false);
      }
    };

    fetchUserImage();

    // Clean up the object URL when component unmounts
    return () => {
      if (userImage) {
        URL.revokeObjectURL(userImage);
      }
    };
  }, []);

  const toggleNavbar = (): void => {
    setIsCollapsed((prev) => !prev);
  };

  const toggleDropdown = (): void => {
    setIsDropdownOpen((prev) => !prev);
  };

  // const handleLogout = (): void => {
  //   localStorage.removeItem("accessToken");
  //   navigate("/login");
  // };

  const handleLogout = (): void => {
    // Clear local storage
    localStorage.clear();

    // Clear session storage
    sessionStorage.clear();

    // MSAL logout
    // instance.logoutRedirect({
    //   postLogoutRedirectUri: "/login",
    // });

    // Clear all local storage
    localStorage.removeItem("accessToken");
    localStorage.removeItem("tokenKey");
    localStorage.removeItem("roleKey");
    localStorage.removeItem("userName");
    localStorage.removeItem("apiManagement");
    localStorage.removeItem("role");

    // Use MSAL to properly logout
    instance.logoutRedirect({
      postLogoutRedirectUri: "/login",  // Redirect to login page after logout
    }).catch(error => {
      console.error("Logout failed:", error);
      // Fallback to manual navigation if logout fails
      navigate("/login");
    });
  };

  return (
    <div className={`${styles.navContainer} ${isCollapsed ? styles.collapsed : ""}`}>
      <div className={styles.logoDiv}>
        <img src={isCollapsed ? ShortLogo : StarLogo} height={50} alt="Logo" />
      </div>

      <div className={styles.navItems}>
        <Link to="/" className={`${styles.navItem} ${activePage === "/" ? styles.active : ""}`}>
          <img src={HomeIcon} alt="Home" />
          {!isCollapsed && <span>Home</span>}
        </Link>

        <Link to="/dashboard" className={`${styles.navItem} ${activePage === "/dashboard" ? styles.active : ""}`}>
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="17" viewBox="0 0 16 17" fill="none">
        <g opacity="0.5">
<path d="M6.66667 2.71606H2V7.38273H6.66667V2.71606Z" stroke="white" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M14 2.71606H9.33334V7.38273H14V2.71606Z" stroke="white" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M14 10.0493H9.33334V14.716H14V10.0493Z" stroke="white" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M6.66667 10.0493H2V14.716H6.66667V10.0493Z" stroke="white" stroke-linecap="round" stroke-linejoin="round"/>
</g>
</svg>
          {!isCollapsed && <span>Dashboard</span>}
        </Link>

        <div className={`${styles.navItem} ${isDropdownOpen ? styles.active : ""}`} onClick={toggleDropdown}>
          <img src={DocIcon} alt="Evidence Upload" />
          {!isCollapsed && <span>Q2 Evidence Uploads</span>}
          {isDropdownOpen ? <KeyboardArrowUpIcon sx={{ color: "#fff" }} /> : <ExpandMoreIcon sx={{ color: "#fff" }} />}
        </div>

        {isDropdownOpen && (
          <div className={`${styles.dropdownMenu} ${isCollapsed ? styles.collapsedDropdown : ""}`}>
            <div className={styles.dropdownItemscollapsed}>
              <Link style={{ paddingLeft: "40px" }} to="/operations/strategy-value-creation" className={`${styles.navItem} ${activePage.includes("/operations/strategy-value-creation") ? styles.activeSub : ""}`}>
                <span>Strategy & Value Creation</span>
              </Link>
              <Link
                style={{ paddingLeft: "40px" }}
                to="/operations/management"
                className={`${styles.navItem} ${activePage.includes("/operations/management") || activePage.includes("/operations/people")
                  ? styles.activeSub
                  : ""
                  }`}
              >
                <span>Operations</span>
              </Link>
            </div>
          </div>
        )}

{role === 'super_admin' && (<Link to="/feedback" className={`${styles.navItem} ${activePage === "/feedback" ? styles.active : ""}`}>
           {/* <img src={HomeIcon} alt="Home" />  */}
          <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 19 19" fill="none">
            <g opacity="0.5">
              <path d="M13.3333 5.38258H2.66659C1.93021 5.38258 1.33325 5.97954 1.33325 6.71592V13.3826C1.33325 14.119 1.93021 14.7159 2.66659 14.7159H13.3333C14.0696 14.7159 14.6666 14.119 14.6666 13.3826V6.71592C14.6666 5.97954 14.0696 5.38258 13.3333 5.38258Z" stroke="white" stroke-linecap="round" stroke-linejoin="round" />
              <path d="M10.6666 14.7159V4.04925C10.6666 3.69562 10.5261 3.35648 10.2761 3.10644C10.026 2.85639 9.68687 2.71591 9.33325 2.71591H6.66659C6.31296 2.71591 5.97383 2.85639 5.72378 3.10644C5.47373 3.35648 5.33325 3.69562 5.33325 4.04925V14.7159" stroke="white" stroke-linecap="round" stroke-linejoin="round" />
            </g>
          </svg>
          {!isCollapsed && <span>  Review and Feedback</span>}
        </Link>)}



        <Link to="/help" className={`${styles.navItem} ${activePage === "/help" ? styles.active : ""}`}>
          {/* <img src={HomeIcon} alt="Home" /> */}
          <svg xmlns="http://www.w3.org/2000/svg"  width="22" height="22" viewBox="0 0 16 16" fill="none">
<g opacity="0.5" clip-path="url(#clip0_10140_50466)">
<path d="M8.00004 14.6668C11.6819 14.6668 14.6667 11.6821 14.6667 8.00016C14.6667 4.31826 11.6819 1.3335 8.00004 1.3335C4.31814 1.3335 1.33337 4.31826 1.33337 8.00016C1.33337 11.6821 4.31814 14.6668 8.00004 14.6668Z" stroke="white" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M6.06006 5.99989C6.21679 5.55434 6.52616 5.17863 6.93336 4.93931C7.34056 4.7 7.81932 4.61252 8.28484 4.69237C8.75036 4.77222 9.1726 5.01424 9.47678 5.37558C9.78095 5.73691 9.94743 6.19424 9.94672 6.66656C9.94672 7.99989 7.94673 8.66656 7.94673 8.66656" stroke="white" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M8 11.3335H8.00667" stroke="white" stroke-linecap="round" stroke-linejoin="round"/>
</g>
<defs>
<clipPath id="clip0_10140_50466">
<rect width="16" height="16" fill="white"/>
</clipPath>
</defs>
</svg>
          {!isCollapsed && <span> Help</span>}
        </Link>

      </div>

      <div className={styles.userDiv}>
        {showLogout ? (
          <Button variant="contained" sx={{ mt: 1, bgcolor: "#fff", color: "#000" }} onClick={handleLogout}>
            Logout
          </Button>
        ) : (
          <div style={{ display: 'flex', gap: '8px' }}>
            {imageLoading ? (
              <div style={{ width: '40px', height: '40px', backgroundColor: '#ccc', borderRadius: '50%' }} />
            ) : (
              <img
                src={userImage || UserImg}
                alt="User"
                style={{ width: '40px', height: '40px', borderRadius: '50%', objectFit: 'cover' }}
                onError={(e) => {
                  // Fallback to default image if the fetched image fails to load
                  const target = e.target as HTMLImageElement;
                  target.src = UserImg;
                }}
              />
            )}
            {!isCollapsed && (
              <div>
                <p className={styles.username}>{localStorage.getItem("userName")}</p>
                <p style={{ color: '#fff', fontSize: '12px', paddingTop: '5px' }}>
                  {localStorage.getItem("role")}
                </p>
              </div>
            )}
          </div>
        )}
        <MoreVertIcon sx={{ color: "#fff", cursor: "pointer" }} onClick={() => setShowLogout((prev) => !prev)} />
      </div>

      <div className={styles.toggleButton} onClick={toggleNavbar}>
        {isCollapsed ? <ArrowForwardIosIcon sx={{ color: "#fff" }} /> : <ArrowBackIosNewIcon sx={{ color: "#fff" }} />}
      </div>
    </div>
  );
};

export default VerticalNavbar;